import { Option } from '@cmg/common';

import { InstitutionalIndicationOrderType } from '../../graphql';

export const institutionalIndicationOrderTypeLabels = {
  [InstitutionalIndicationOrderType.Limit]: 'Limit',
  [InstitutionalIndicationOrderType.Market]: 'Market',
  [InstitutionalIndicationOrderType.Pass]: 'Pass',
  [InstitutionalIndicationOrderType.Scaled]: 'Scaled',
};

export const institutionalIndicationOrderTypeOptions = Object.values(
  InstitutionalIndicationOrderType
).map<Option<InstitutionalIndicationOrderType>>(orderType => ({
  label: institutionalIndicationOrderTypeLabels[orderType],
  value: orderType,
}));

export const institutionalIndicationInterestLevelOrderTypeOptions =
  institutionalIndicationOrderTypeOptions.filter(
    option =>
      option.value === InstitutionalIndicationOrderType.Limit ||
      option.value === InstitutionalIndicationOrderType.Market
  );
